import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { SuketIstirahatInterface } from "@/types/suket_istirahat";
import SvcSuketIstirahat from "@/services/SuketIstirahat";
import { storePasien } from "@/store/modules/pasien";

@Module({ dynamic: true, namespaced: true, store, name: "SuketIstirahat" })
class SuketIstirahat extends VuexModule {
  suket: Array<SuketIstirahatInterface> = [];
  loading = false;

  get pasien(): any {
    return storePasien.identitasPasien;
  }

  // get suket(): SuketIstirahatInterface {
  //   return this._suket;
  // }

  // get loading(): boolean {
  //   return this._loading;
  // }

  @Mutation
  SET_SUKET(suket: Array<SuketIstirahatInterface>) {
    this.suket = suket;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action({ rawError: true })
  async fetchSuketByRegister(): Promise<void> {
    this.SET_LOADING(true);

    const suketArray = await SvcSuketIstirahat.getByRegister(
      this.pasien.register.no
    ).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_SUKET(suketArray.data);
  }

  @Action({ rawError: true })
  async getSuketByRegister(noReg): Promise<void> {
    this.SET_LOADING(true);

    const suketArray = await SvcSuketIstirahat.getByRegister(
      noReg
    ).finally(() => {
      this.context.commit('SET_LOADING', false);
    });

    this.SET_SUKET(suketArray.data);
  }
}

export default getModule(SuketIstirahat);
